import InspectionDetails from './InspectionDetails-compose';

export default InspectionDetails;
